module.exports = "/images/backgroundMobileLoading.svg";